export const UI_SET_PANEL_VISIBILITY = 'UI_SET_PANEL_VISIBILITY'
export const UI_SET_LIST_VISIBILITY = 'UI_SET_LIST_VISIBILITY'
export const UI_SET_MOBILE_CARD_VISIBILITY = 'UI_SET_MOBILE_CARD_VISIBILITY'
